import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { configureDashMaps } from '@/design-system/lib/google-maps';

// Kit map components (LocationPreview, PlacesAutocomplete, DashMap) read the
// Google Maps key from this framework-agnostic config instead of process.env.
const gmapsKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
if (gmapsKey) {
  configureDashMaps({ apiKey: gmapsKey });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
